import React from 'react';
import { motion } from 'framer-motion';
import WhyUsImg from '../assets/WhyUs.png';

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.2, duration: 0.6 },
  }),
};

const features = [
  {
    title: "Secure Campus Deals",
    description: "Every transaction is made within the university for your safety and peace of mind.",
  },
  {
    title: "Verified Sellers",
    description: "Shop from trusted students.",
  },
  {
    title: "Essentials & Fashion",
    description: "Get your tech, clothes, accessories and daily essentials in one place.",
  },
  {
    title: "Delivery Handled by Us",
    description: "Forget meetups — we manage delivery so you don’t have to."
  },
];

const WhyShopWithUs = () => {
  return (
    // 1. Added granular padding for mobile vs desktop & overflow-hidden to prevent animation scrollbars
    <section className="px-4 sm:px-6 lg:px-16 py-12 md:py-20 bg-black/30 text-white font-['Space_Grotesk'] overflow-hidden">
      
      {/* 2. Added max-w-7xl and mx-auto so it doesn't stretch infinitely on huge monitors */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        
        {/* 3. Image Container: Changed order so Text appears BEFORE Image on mobile */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="order-2 lg:order-1 w-full max-w-md mx-auto lg:max-w-none"
        >
          <img
            src={WhyUsImg}
            alt="Why Shop With Us"
            className="w-full h-auto rounded-3xl shadow-2xl border border-white/20 object-cover"
          />
        </motion.div>

        {/* 4. Text Container: Centered on mobile, left-aligned on desktop */}
        <div className="order-1 lg:order-2 text-center lg:text-left">
          
          {/* 5. Fluid Typography for the heading */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold bg-gradient-to-r from-green-400 via-cyan-400 to-blue-400 text-transparent bg-clip-text mb-8 leading-tight sm:leading-tight">
            Why Shop With Us?
          </h2>
          
          {/* Features Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 text-left">
            {features.map((feat, i) => (
              <motion.div
                key={i}
                custom={i}
                variants={cardVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                // Added hover effect for a bit more interactivity
                className="p-5 rounded-2xl border border-white/10 bg-white/10 backdrop-blur shadow-xl hover:bg-white/15 transition-colors"
              >
                <h3 className="text-lg sm:text-xl font-bold mb-2 text-green-300">{feat.title}</h3>
                <p className="text-sm sm:text-base text-gray-200">{feat.description}</p>
              </motion.div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default WhyShopWithUs;